import React from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useLoginMutation } from "../../services/authApiSlice";
import { Branding } from "../../component/branding/Branding";
import { FormInput } from "../../component/shared/formElements/formInput/FormInput";
import { useForm } from "react-hook-form";
import classes from "./loginPage.module.css";

export const LoginPage = () => {
  const navigate = useNavigate();

  const [login, { isLoading }] = useLoginMutation();

const {
  register,
  handleSubmit,
  reset,
  watch,
  formState: { errors, isValid, isSubmitting },
} = useForm({
  mode: "onChange",
  reValidateMode: "onChange",
  criteriaMode: "all",
  shouldFocusError: true,
});
watch();

  // ✅ submit handler
  const onSubmit = async (data) => {
    const toastId = toast.loading("Signing in...");

    try {
      const response = await login({
        email_id: data.email,
        password: data.password,
      }).unwrap();

      toast.update(toastId, {
        render: response.message.displayMessage,
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });

      navigate("/");
    } catch (err) {
      toast.update(toastId, {
        render:
          err?.data?.message?.displayMessage || "Invalid email or password",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  return (
    <div className={classes.box}>
      <div className={classes.box__section}>
        <Branding />

        <form
          onSubmit={handleSubmit(onSubmit)}
          className={classes.box__section__form}
        >
          {/* Email */}
          <FormInput
            id="email"
            type="email"
            label="Email"
            placeholder="Enter your email"
            register={register}
            validation={{
              required: "Email is required",
              pattern: {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                message: "Enter a valid email address",
              },
            }}
            error={errors.email?.message}
            required
          />

          {/* Password */}
          <FormInput
            id="password"
            type="password"
            label="Password"
            placeholder="Enter your password"
            register={register}
            validation={{
              required: "Password is required",
              minLength: {
                value: 5,
                message: "Password must be at least 5 characters long",
              },
            }}
            error={errors.password?.message}
            required
          />

          {/* Submit Button */}
          <button
            type="submit"
            disabled={isLoading || isSubmitting}
            className={
              isLoading || isSubmitting
                ? classes.box__section__form__submitBtn__disabled
                : classes.box__section__form__submitBtn
            }
          >
            {isLoading || isSubmitting ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};
